<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONTRATOS - Consumo de quantidade por subitem</span>
                </h4>

                <b-form-group label="Contrato:" label-for="selectContrato">
                    <b-form-select
                        id="selectContrato"
                        v-model="filtro.contratoId"
                        :options="[
                            {
                                contratoId: null,
                                codContrato: 'Selecione um contrato'
                            },
                            ...contratoOptions
                        ]"
                        value-field="contratoId"
                        text-field="codContrato"
                        class="form-control form-control-sm"
                        style="width: 200px;" 
                    />
                </b-form-group>
            </b-card-body>

            <b-card-footer>
                <app-btn-voltar></app-btn-voltar>
                <b-button
                    variant="primary"
                    class="ml-2"
                    @click.stop="emitirRelatorio()"
                    :disabled="!filtro.contratoId"
                >
                    <span>
                        <i class="fa fa-file-excel-o mr-2"></i> Emitir Relatório
                    </span>
                </b-button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import RelatoriosServicos from './RelatoriosServicos'
import ContratosServicos from '../../fornecedor/contratos/ContratosServicos'

export default {
    data() {
        return {
            contratos: [],
            filtro: {
                contratoId: null
            }
        }
    },

    computed: {
        contratoOptions() {
            return this.contratos || []
        }
    },

    methods: {
        obterContratos() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterContratos().then(response => {
                if (response) {
                    if (response.success) {
                        this.contratos = response.data.map(c => ({
                            contratoId: c.contratoId,
                            codContrato: c.codContrato
                        }))
                    } else {
                        this.erros = ['Erro ao obter contratos']
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        emitirRelatorio() {
            this.$store.dispatch('addRequest')

            RelatoriosServicos.exportarPlanilhaSubItens(
                this.filtro.contratoId
            ).then(response => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, 'ConsumoQtdSubitens.xlsx')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterContratos()
    }
}
</script>
